var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toaster",class:_vm.visibility},[_c('div',{staticClass:"toaster-box",class:_vm.level},[_c('div',[_c('i',{class:{
          'icon-success': _vm.level == 'success',
          'icon-warning': _vm.level == 'warning',
          'icon-error': _vm.level == 'error',
        }}),_vm._v(" "+_vm._s(_vm.message)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }